import customAxios from "./axiosConfig";
const PlanService = {
    list: function (params) {
        var api_url = window.Urls['plan-list']();
        return customAxios.get(api_url, {params: params});
    },
    create: function (data) {
        var api_url = window.Urls['plan-create-premium-plan']();
        return customAxios.post(api_url, data);
    },
    upgradeFreePlan: function (pk, data) {
        var api_url = window.Urls['plan-upgrade-free-plan'](pk);
        return customAxios.post(api_url, data);
    },
    repayPlan: function () {
        var api_url = window.Urls['plan-repay-plan']();
        return customAxios.get(api_url);
    },
    // TODO get new payment link
    addTeamMember: function (data){ // { team_members: n } n = exta members
        var api_url = window.Urls['plan-add-team']();
        return customAxios.post(api_url, data);
    },
    getNextPayment (pk, params) {
        const api_url = window.Urls['plan_price'](pk)
        return customAxios.get(api_url, { params: params })
    },
    changeTier: function (data) {
        var api_url = window.Urls["plan-update-tier"]();
        return customAxios.post(api_url, data);
    },
    getNextTier: function () {
        var api_url = window.Urls["plan-next-tier"]();
        return customAxios.get(api_url);
    },
    getUpcomingTier: function (pk) {
        var api_url = window.Urls["plan-tier"](pk);
        return customAxios.get(api_url);
    }
};
export default PlanService;